



























import { Vue, Component } from "vue-property-decorator";
import FscPageHeader from "@/components/FscPageHeader.vue";
import KiPilotTheorieTable from "@/views/Exam/KiPilotTheorie/KiPilotTheorieTable.vue";
import KiPilotTheorieFunctionCard from "@/views/Exam/KiPilotTheorie/KiPilotTheorieFunctionCard.vue";
import KiPilotTheoriePredictionHistory from "@/views/Exam/KiPilotTheorie/KiPilotTheoriePredictionHistory.vue";
import KiPilotTheorieInsights from "@/views/Exam/KiPilotTheorie/KiPilotTheorieInsights.vue";

interface KiPilotTheorieFunction {
  key: string;
  title: string;
  description: string;
  url: string;
}

const LAST_USED_STORAGE_KEY = "kiPilotTheorieLastUsedFunctionKey";

@Component({
  components: {
    KiPilotTheorieTable,
    KiPilotTheorieFunctionCard,
    KiPilotTheoriePredictionHistory,
    KiPilotTheorieInsights,
    FscPageHeader,
  },
})
export default class KiPilotTheorie extends Vue {
  public name = "KiPilotTheorie";

  public activeKey = "";

  public lastUsedKey = localStorage.getItem(LAST_USED_STORAGE_KEY) || "";

  public beforeDestroy(): void {
    this.lastUsedKey = "";
    localStorage.removeItem(LAST_USED_STORAGE_KEY);
  }

  public get functions(): KiPilotTheorieFunction[] {
    return [
      {
        key: "already-assigned",
        title: this.$t("ki_pilot_theorie.already_assigned_title") as string,
        description: this.$t("ki_pilot_theorie.already_assigned_description") as string,
        url: "examiner/predict-batch-b-category-already-assigned-to-exam",
      },
      {
        key: "active-not-assigned",
        title: this.$t("ki_pilot_theorie.active_not_assigned_title") as string,
        description: this.$t("ki_pilot_theorie.active_not_assigned_description") as string,
        url: "examiner/predict-batch-b-category-active-not-assigned-to-exam",
      },
    ];
  }

  public get isLoading(): boolean {
    return !!this.activeKey;
  }

  public async onStart(fn: KiPilotTheorieFunction): Promise<void> {
    this.activeKey = fn.key;
    this.lastUsedKey = fn.key;
    localStorage.setItem(LAST_USED_STORAGE_KEY, fn.key);
    try {
      await (this.$refs.kiPilotTheorieTable as KiPilotTheorieTable).loadData(fn.url);
    } finally {
      this.activeKey = "";
    }
  }

  public async onRowClicked(item: any): Promise<void> {
    if (!item?.studentEducationId) return;
    await (this.$refs.kiPilotTheoriePredictionHistory as KiPilotTheoriePredictionHistory).open(item.studentEducationId, item.studentName, item.studentSurname);
  }

  public onInsightsClicked(item: any): void {
    if (!item?.studentEducationId) return;
    (this.$refs.kiPilotTheorieInsights as KiPilotTheorieInsights).open(item.studentEducationId, item.studentName, item.studentSurname);
  }
}
